<template>
  <div class="form-group" :class="setPlaceholderClasses">
    <textarea
      :value="value"
      :id="id"
      class="form-control"
      @input="update()"
      ref="input"
      :rows="rows"
    />
    <label :for="id">{{ text }}</label>
  </div>
</template>
<script>
import placeholder from "@mixins/placeholder.js";
export default {
  name: "volcan-input-textarea",
  mixins: [placeholder],
  props: {
    text: String,
    rows: {
      type: Number,
      default: 3,
    },
  },
  data: function () {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  computed: {},
  watch: {},
  methods: {
    update() {
      this.$emit("input", this.$refs.input.value);
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-textarea.vue